import { DrmFontsResponseDto } from '@diritto/common/font/dtos/drm-fonts.response.dto';
import { Http } from '@diritto/common/utils/requester/http';

export class DrmFontApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getFonts(): Promise<DrmFontsResponseDto> {
    const res = await this.http.get<DrmFontsResponseDto>(`${this.url}/drm/fonts`);
    return res.data;
  }
}
